import styled from 'styled-components';

const ModalBody = styled.div`
  display: flex;
  flex: 1;
  gap: 24px;
`;

const Col = styled.div`
  display: flex;
  flex: 0.5;
  flex-direction: column;
  gap: 8px;
`;

const SubText = styled.p`
  color: var(--color-accent-secondary-default);
  font-size: 16px;
  font-weight: 600;
  text-align: center;
`;

export { Col, ModalBody, SubText };
